import { render, staticRenderFns } from "./ShoppingCartCard.vue?vue&type=template&id=0033b088&scoped=true"
import script from "./ShoppingCartCard.vue?vue&type=script&lang=js"
export * from "./ShoppingCartCard.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartCard.vue?vue&type=style&index=0&id=0033b088&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033b088",
  null
  
)

export default component.exports